import LinearProgress from '@mui/joy/LinearProgress';

export const UiProgress = (props: {
    value: number,
}) => {
    return <LinearProgress determinate value={props.value} />;
};
